import { Record, List } from 'immutable'

const DimensionTargetRecord = Record({
  id: undefined,
  dimensionValueIds: List(),
})

export default DimensionTargetRecord
